import React from 'react';
import ModernCTA from '../../components/ModernCTA';

const ITConsulting = () => {
  return (
    <div className="it-consulting-page">
      <style jsx>{`
        .it-consulting-page {
          margin-top: 80px;
          color: #f8fafc;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
          overflow-x: hidden;
        }
        
        .container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        
        /* Hero Section */
        .hero-section {
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          padding: 60px 0 80px;
          text-align: center;
          position: relative;
          overflow: hidden;
        }
        
        .hero-section::before {
          content: '';
          position: absolute;
          top: -50%;
          left: -50%;
          width: 200%;
          height: 200%;
          background: radial-gradient(circle, rgba(99, 102, 241, 0.1) 0%, transparent 70%);
          animation: pulse 15s infinite linear;
        }
        
        @keyframes pulse {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
        
        .hero-section h1 {
          font-size: 2.2rem;
          font-weight: 800;
          margin-bottom: 1.2rem;
          background: linear-gradient(to right, #e2e8f0, #94a3b8);
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
          line-height: 1.2;
          position: relative;
          z-index: 1;
          animation: fadeInUp 0.8s ease-out;
          padding: 0 10px;
        }
        
        .hero-section .lead {
          font-size: 1.1rem;
          max-width: 100%;
          margin: 0 auto;
          color: #cbd5e1;
          line-height: 1.6;
          position: relative;
          z-index: 1;
          animation: fadeInUp 0.8s ease-out 0.2s;
          animation-fill-mode: both;
          padding: 0 15px;
        }
        
        /* Services Section */
        .services-section {
          padding: 60px 0;
          background-color: #0f172a;
          position: relative;
        }
        
        .services-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(to right, transparent, #6366f1, transparent);
        }
        
        .section-title {
          font-size: 1.8rem;
          font-weight: 700;
          text-align: center;
          margin-bottom: 40px;
          color: #e2e8f0;
          position: relative;
          animation: fadeIn 0.8s ease-out;
          padding: 0 15px;
        }
        
        .section-title::after {
          content: '';
          display: block;
          width: 60px;
          height: 4px;
          background: linear-gradient(to right, #6366f1, #8b5cf6);
          margin: 15px auto 0;
          border-radius: 2px;
        }
        
        .services-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 25px;
          margin-top: 40px;
        }
        
        .service-card {
          background: linear-gradient(145deg, #1e293b 0%, #1a2538 100%);
          border-radius: 12px;
          padding: 30px 20px;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1);
          border: 1px solid #334155;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
          position: relative;
          overflow: hidden;
          animation: fadeInUp 0.6s ease-out;
          animation-fill-mode: both;
        }
        
        .service-card:nth-child(1) { animation-delay: 0.1s; }
        .service-card:nth-child(2) { animation-delay: 0.2s; }
        .service-card:nth-child(3) { animation-delay: 0.3s; }
        
        .service-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(135deg, rgba(99, 102, 241, 0.1) 0%, transparent 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
        }
        
        .service-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 15px -5px rgba(0, 0, 0, 0.2), 0 5px 5px -5px rgba(0, 0, 0, 0.1);
          border-color: #4f46e5;
        }
        
        .service-card:hover::before {
          opacity: 1;
        }
        
        .service-icon {
          width: 50px;
          height: 50px;
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 20px;
          transition: transform 0.3s ease;
        }
        
        .service-card:hover .service-icon {
          transform: rotate(-5deg) scale(1.1);
        }
        
        .service-icon svg {
          width: 25px;
          height: 25px;
          color: white;
        }
        
        .service-card h3 {
          font-size: 1.3rem;
          font-weight: 600;
          margin-bottom: 12px;
          color: #e2e8f0;
          position: relative;
        }
        
        .service-card p {
          color: #94a3b8;
          line-height: 1.6;
          margin-bottom: 15px;
          transition: color 0.3s ease;
          font-size: 0.95rem;
        }
        
        .service-card:hover p {
          color: #cbd5e1;
        }
        
        .service-features {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .service-features li {
          padding: 6px 0;
          color: #cbd5e1;
          position: relative;
          padding-left: 22px;
          transition: transform 0.3s ease, color 0.3s ease;
          font-size: 0.9rem;
        }
        
        .service-features li:hover {
          color: #ffffff;
          transform: translateX(3px);
        }
        
        .service-features li::before {
          content: '✓';
          position: absolute;
          left: 0;
          color: #6366f1;
          font-weight: bold;
          transition: color 0.3s ease;
        }
        
        .service-features li:hover::before {
          color: #8b5cf6;
        }
        
        /* Approach Section */
        .approach-section {
          padding: 60px 0;
          background: linear-gradient(135deg, #0f172a 0%, #1a253a 100%);
          position: relative;
        }
        
        .approach-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(to right, transparent, #8b5cf6, transparent);
        }
        
        .approach-steps {
          max-width: 800px;
          margin: 0 auto;
        }
        
        .step {
          display: flex;
          margin-bottom: 30px;
          position: relative;
          animation: fadeInRight 0.6s ease-out;
          animation-fill-mode: both;
          flex-direction: column;
        }
        
        .step:nth-child(1) { animation-delay: 0.1s; }
        .step:nth-child(2) { animation-delay: 0.2s; }
        .step:nth-child(3) { animation-delay: 0.3s; }
        .step:nth-child(4) { animation-delay: 0.4s; }
        
        .step:last-child {
          margin-bottom: 0;
        }
        
        .step-number {
          width: 40px;
          height: 40px;
          background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 700;
          font-size: 1.1rem;
          flex-shrink: 0;
          margin-bottom: 15px;
          box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
          transition: transform 0.3s ease;
        }
        
        .step:hover .step-number {
          transform: scale(1.1) rotate(5deg);
        }
        
        .step-content {
          padding-top: 0;
        }
        
        .step-content h3 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 8px;
          color: #e2e8f0;
          transition: color 0.3s ease;
        }
        
        .step:hover .step-content h3 {
          color: #8b5cf6;
        }
        
        .step-content p {
          color: #94a3b8;
          line-height: 1.6;
          transition: color 0.3s ease;
          font-size: 0.95rem;
        }
        
        .step:hover .step-content p {
          color: #cbd5e1;
        }
        
        /* Benefits Section */
        .benefits-section {
          padding: 60px 0;
          background-color: #0f172a;
          position: relative;
        }
        
        .benefits-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 2px;
          background: linear-gradient(to right, transparent, #6366f1, transparent);
        }
        
        .benefits-grid {
          display: grid;
          grid-template-columns: 1fr;
          gap: 20px;
          margin-top: 40px;
        }
        
        .benefit-card {
          background: linear-gradient(145deg, #1e293b 0%, #1a2538 100%);
          border-radius: 12px;
          padding: 25px;
          border: 1px solid #334155;
          transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.1);
          animation: fadeInUp 0.6s ease-out;
          animation-fill-mode: both;
        }
        
        .benefit-card:nth-child(1) { animation-delay: 0.1s; }
        .benefit-card:nth-child(2) { animation-delay: 0.2s; }
        .benefit-card:nth-child(3) { animation-delay: 0.3s; }
        .benefit-card:nth-child(4) { animation-delay: 0.4s; }
        
        .benefit-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 10px 15px -5px rgba(0, 0, 0, 0.2), 0 5px 5px -5px rgba(0, 0, 0, 0.1);
          border-color: #4f46e5;
        }
        
        .benefit-card h3 {
          font-size: 1.1rem;
          font-weight: 600;
          margin-bottom: 12px;
          color: #e2e8f0;
          display: flex;
          align-items: center;
        }
        
        .benefit-card h3 svg {
          width: 18px;
          height: 18px;
          color: #6366f1;
          margin-right: 8px;
          transition: all 0.3s ease;
        }
        
        .benefit-card:hover h3 svg {
          color: #8b5cf6;
          transform: rotate(10deg) scale(1.1);
        }
        
        .benefit-card p {
          color: #94a3b8;
          line-height: 1.6;
          transition: color 0.3s ease;
          font-size: 0.95rem;
        }
        
        .benefit-card:hover p {
          color: #cbd5e1;
        }
        
        /* Animations */
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(20px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }
        
        /* Tablet and Larger Mobile Screens */
        @media (min-width: 480px) {
          .hero-section {
            padding: 80px 0 100px;
          }
          
          .hero-section h1 {
            font-size: 2.5rem;
          }
          
          .services-grid {
            grid-template-columns: 1fr;
          }
          
          .benefits-grid {
            grid-template-columns: 1fr 1fr;
          }
        }
        
        /* Small Desktop and Tablet Landscape */
        @media (min-width: 768px) {
          .it-consulting-page {
            margin-top: 100px;
          }
          
          .hero-section {
            padding: 100px 0 120px;
          }
          
          .hero-section h1 {
            font-size: 3rem;
          }
          
          .hero-section .lead {
            font-size: 1.2rem;
            max-width: 700px;
          }
          
          .section-title {
            font-size: 2.2rem;
          }
          
          .services-grid {
            grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
          }
          
          .benefits-grid {
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
          }
          
          .step {
            flex-direction: row;
          }
          
          .step-number {
            margin-right: 20px;
            margin-bottom: 0;
          }
        }
        
        /* Desktop */
        @media (min-width: 992px) {
          .hero-section h1 {
            font-size: 3.5rem;
          }
          
          .section-title {
            font-size: 2.5rem;
          }
        }
      `}</style>

      <section className="hero-section">
        <div className="container">
          <h1>Transform Your Business with Strategic IT Consulting</h1>
          <p className="lead">We architect technology solutions that drive innovation, efficiency, and competitive advantage for your organization.</p>
        </div>
      </section>

      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Our IT Consulting Services</h2>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z" />
                </svg>
              </div>
              <h3>Strategic Technology Roadmaps</h3>
              <p>We develop comprehensive, future-proof technology strategies aligned with your business objectives. Our roadmaps include phased implementation plans, budget forecasting, and ROI analysis to ensure technology investments deliver maximum value.</p>
              <ul className="service-features">
                <li>3-5 year technology vision</li>
                <li>Emerging technology assessment</li>
                <li>Vendor selection guidance</li>
                <li>Integration strategy development</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c-.94 1.543.826 3.31 2.37 2.37a1.724 1.724 0 002.572-1.065c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573-1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c-.94 1.543.826 3.31 2.37 2.37a1.724 1.724 0 002.572-1.065c.426-1.756-2.924-1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c.94-1.543-.826-3.31-2.37-2.37a1.724 1.724 0 00-2.572 1.065z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
              </div>
              <h3>Digital Transformation Advisory</h3>
              <p>Our experts guide you through complete digital transformation initiatives, from process automation to customer experience enhancement. We help reimagine your business operations for the digital age while minimizing disruption.</p>
              <ul className="service-features">
                <li>Digital maturity assessment</li>
                <li>Workflow automation strategy</li>
                <li>Cloud migration planning</li>
                <li>Change management support</li>
              </ul>
            </div>

            <div className="service-card">
              <div className="service-icon">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 12h14M5 12a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v4a2 2 0 01-2 2M5 12a2 2 0 00-2 2v4a2 2 0 002 2h14a2 2 0 002-2v-4a2 2 0 00-2-2m-2-4h.01M17 16h.01" />
                </svg>
              </div>
              <h3>IT Infrastructure Optimization</h3>
              <p>We analyze and optimize your entire IT infrastructure for performance, security, and cost-efficiency. Our recommendations cover network architecture, data center solutions, cloud/hybrid environments, and end-user computing.</p>
              <ul className="service-features">
                <li>Infrastructure health assessment</li>
                <li>Performance benchmarking</li>
                <li>Cost optimization analysis</li>
                <li>Disaster recovery planning</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="approach-section">
        <div className="container">
          <h2 className="section-title">Our Consulting Approach</h2>
          <div className="approach-steps">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <h3>Discovery & Assessment</h3>
                <p>We conduct in-depth analysis of your current technology landscape, business processes, and strategic objectives through workshops, interviews, and technical audits.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <h3>Gap Analysis</h3>
                <p>We identify gaps between your current state and desired future state, highlighting opportunities for improvement and innovation across people, processes, and technology.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">3</div>
              <div className="step-content">
                <h3>Solution Design</h3>
                <p>Our team architects tailored solutions with detailed implementation roadmaps, considering technical requirements, budget constraints, and organizational change management.</p>
              </div>
            </div>
            <div className="step">
              <div className="step-number">4</div>
              <div className="step-content">
                <h3>Execution Support</h3>
                <p>We provide ongoing guidance during implementation, offering vendor selection assistance, project oversight, and quality assurance to ensure successful delivery.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="benefits-section">
        <div className="container">
          <h2 className="section-title">Why Choose Our IT Consulting</h2>
          <div className="benefits-grid">
            <div className="benefit-card">
              <h3>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
                Technology Agnostic
              </h3>
              <p>We recommend solutions based on your specific needs, not vendor preferences, ensuring unbiased advice that serves your best interests.</p>
            </div>
            <div className="benefit-card">
              <h3>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
                Enterprise-Grade Security
              </h3>
              <p>Security is integrated into every recommendation we make, protecting your systems and data from modern threats.</p>
            </div>
            <div className="benefit-card">
              <h3>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Cost Optimization
              </h3>
              <p>We identify opportunities to reduce IT spend without compromising performance or security, maximizing your technology ROI.</p>
            </div>
            <div className="benefit-card">
              <h3>
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                Future-Proof Solutions
              </h3>
              <p>Our recommendations consider scalability and adaptability, ensuring your technology investments remain valuable as your business evolves.</p>
            </div>
          </div>
        </div>
      </section>

      <ModernCTA />
    </div>
  );
};

export default ITConsulting;